import { Component, OnInit, OnDestroy, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, AfterContentInit, AfterViewInit } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from './../../../model/SubscriptionMgr';
import { CustomSymbolDialogService } from './custom-symbol-dialog.service';
import { AnyHandler } from './../../../types/@types/sl-v-types';
import { SLLayer } from './../../..//model/sl-layer';
import { AttributesService, AttStorageType } from './../../../model/api-services/attributes.service';
import { ModalMessagerService } from './../../../modal-messager/modal-messager.service';
import { FontService } from 'src/app/model/api-services/font.service';
import fontkit, { Font } from '@pdf-lib/fontkit'
import { CharacterMapComponent } from './character-map/character-map.component';
import { UnicodeRange } from 'src/app/services/unicode.service';
import { CharacterSwatchComponent } from './character-swatch/character-swatch.component';
import { UnicodeRangeSelectorComponent } from './unicode-range-selector/unicode-range-selector.component';
import { CharacterInspectorComponent } from './character-inspector/charcter-inspector.component';
export type CustomSymbolDialogInfo = {
  handler: AnyHandler;
  symbol?: string;
}

@Component({
  selector: 'app-custom-symbol-dialog',
  templateUrl: './custom-symbol-dialog.component.html',
  styleUrls: ['./custom-symbol-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomSymbolDialogComponent implements AfterViewInit {
  @HostBinding('class.work-view') workView = true;
  @ViewChild(UnicodeRangeSelectorComponent) rangeSelector: UnicodeRangeSelectorComponent;
  @ViewChild(CharacterInspectorComponent) characterInspector: CharacterInspectorComponent;
  public handler: AnyHandler;
  public title = 'Custom Symbol';
  public fonts = [];
  public fontSize = '13pt';
  private _ready = false;

  private _range?: UnicodeRange;
  public set range(range: UnicodeRange) {
    this._range = range;
    this.fromCode = this._range.range[0];
    this.toCode = this._range.range[1];
    this.charMap?.DrawMap();
    this.Refresh();
  }
  public get range(): UnicodeRange {
    return this._range;
  }
  private _currentFont = '';
  public get currentFont(): string {
    return this._currentFont;
  }
  public set currentFont(font: string) {
    if (this._currentFont === font) return;
    this._currentFont = font;
    this.Refresh();
  }
  public SetCurrentFont(font: string): Promise<any> {
    this.currentFont = font;
    return this.fontSvc.GetFontKitFont(this.currentFont).then((value: any) => {
      this.currentFontData = value;
      this.rangeSelector.fontkitFont = this.currentFontData;
      this.Refresh();
    });
  }

  public fromCode = -1;
  public toCode = -1;

  private _currentFontData?: Font;
  public set currentFontData(data: Font) {
    this._currentFontData = data;
    this.Refresh();
  }
  public get currentFontData(): Font {
    return this._currentFontData;
  }

  @ViewChild('charMap') charMap: CharacterMapComponent;

  public fontInfo: Array<any> = [];
  public rangeData: Array<any> = [];
  constructor(private activeModal: NgbActiveModal,
    private messager: ModalMessagerService,
    private fontSvc: FontService, private cdr: ChangeDetectorRef) {
    this.fontSvc.ListSymbolFonts();
  }

  Copy(clipboard: boolean = true): string {
    const font = this.currentFont;
    const char = this.characterInspector.codeText;
    const size = this.characterInspector.displaySize;
    const x = this.characterInspector.xOffset;
    const y = this.characterInspector.yOffset;
    const theta = this.characterInspector.rotation;
    const data = [font, char, size, x, y, theta];
    const dataString = 'custom:' + data.join(',');
    if (!!clipboard) {
      navigator.clipboard.writeText(dataString);
    }
    return dataString;
  }
  Paste() {
    navigator.clipboard.read().then((results) => {
      if (results.length === 0) return;
      for (const result of results) {
        if (!result.types.includes('text/plain')) {
          continue;
        }
        result.getType('text/plain').then((data) => {
          data.text().then((val) => {
            this.SetSymbol(val);
          })
        });
        return;
      }
    }).finally(() => {/*do nothing*/ });
  }
  private _symbol: string = '';
  private _settingSymbol: boolean = false;
  SetSymbol(symbol) {
    if (!this._ready) this._symbol = symbol;
    this._settingSymbol = true;
    const custom = ('' + symbol).split(':');
    if (custom[0] === 'custom') {
      const [font, char, size, x, y, theta] = custom[1]?.split(',');
      this.SetCurrentFont(font).then(() => {
        this.rangeSelector?.SelectByCharacterCode(Number('0x' + char));
        window.requestAnimationFrame(() => {
          this.charMap.SelectByCode(Number('0x' + char));
          window.requestAnimationFrame(() => {
            let unit = size.substring(-2);
            let ptSize = 0;
            switch (unit) {
              case 'pt':
                ptSize = Number(size.substring(0, size.length - 2));

                break;
              case 'px':
                ptSize = Number(size.substring(0, size.length - 2)) * 1.33;
                break;
              default:
                ptSize = Number(size);
            }
            this.UpdateCharMap(ptSize, x, y, theta);
          });
        });
      });

    } else {
      if (custom[0].length < 8) {
        const char = Number('0x' + custom[0]);
        if (isNaN(char)) return;
        this.rangeSelector.SelectByCharacterCode(char);
        window.requestAnimationFrame(() => {
          this.charMap.SelectByCode(char);

        })
      }
    }
  }
  UpdateCharMap(ptSize, x, y, theta) {
    if (!this.characterInspector) {
      window.setTimeout(() => {
        this.UpdateCharMap(ptSize, x, y, theta);
      });
      return;
    }
    this.characterInspector.displaySize = ptSize;
    this.characterInspector.xOffset = Number(x);
    this.characterInspector.yOffset = Number(y);
    this.characterInspector.rotation = Number(theta);
    this.Refresh();
  }
  HandleRange(unicodeRange: UnicodeRange) {
    this.fromCode = unicodeRange.range[0];
    this.toCode = unicodeRange.range[1];
    if (unicodeRange === undefined) {
      return;
    }
    if (!unicodeRange) {
      return;
    }
    this.rangeData = [];
    for (let i = this.fromCode; i < this.toCode; i++) {
      if (this.currentFontData.hasGlyphForCodePoint(i)) {
        if (!this.fontInfo[i]) {
          this.fontInfo[i] = {
            name: (i).toString(16).padStart(4, '0').toUpperCase(),
            tags: [],
            code: i,
            range: unicodeRange.name
          }
        }
        this.rangeData.push(this.fontInfo[i]);

      }
    }
    this.cdr.detectChanges();
    this.charMap.DrawMap();

  }
  Show(info: CustomSymbolDialogInfo) {
    if (this.fonts.length === 0) {
      this.fontSvc.ListSymbolFonts().then((response: any) => {
        if (!response) return;
        this.fonts = response;
        this.Refresh();
        this.Show(info);
      });
      return;
    }

    this.handler = info.handler;

    if (info.symbol) {
      if (!this._ready) {
        this._symbol = info.symbol;
      } else {
        this.SetSymbol(info.symbol);
      }
    }
  }

  public swatch?: CharacterSwatchComponent;
  HandleSwatchSelection(swatch: CharacterSwatchComponent) {
    this.swatch = swatch;
    this.Refresh();
  }
  Cancel() {
    this.Close();

  }
  Submit() {
    if (!!this.handler) {
      this.handler(this.Copy(false));
      this.Close();
    }
  }
  Close() {
    this.activeModal.close();
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
  public pasteAllowed = false;
  public copyAllowed = false;
  ngAfterViewInit() {
    this._ready = true;
    if (this._symbol !== '') {
      this.SetSymbol(this._symbol);
    }
  }

}

@Component({
  selector: 'app-custom-symbol-dialog-entry',
  template: ''
})
export class CustomSymbolDialogEntryComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: CustomSymbolDialogService) {

    this.subscriptionMgr.Subscribe(this.service.request$, (info: CustomSymbolDialogInfo) => {
      this.modalRef = this.modalService.open(CustomSymbolDialogComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as CustomSymbolDialogComponent).Show(info);
    });
  }
  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
  }
}

